import React from 'react';
import ShowMore from './nextSteps/components/ShowMore';
import { truncateLongPercentageValues } from './utils';

const NO_MESSAGE_TEXT = 'No message has been set for this detector.';
const LENGTH_LIMIT = 500;
const AlertEventMessage = React.memo(({ sanitizer, markdownConverter, message }) => {
    const renderMessageMarkup = (text) => {
        const truncated = truncateLongPercentageValues(text);
        return <div dangerouslySetInnerHTML={{ __html: createMarkup(truncated) }} />;
    };

    const createMarkup = (text) => {
        return sanitizer(markdownConverter.makeHtml(text));
    };

    return !message ? (
        NO_MESSAGE_TEXT
    ) : (
        <ShowMore text={message} maxLength={LENGTH_LIMIT} textRenderer={renderMessageMarkup} />
    );
});

export default AlertEventMessage;
AlertEventMessage.displayName = 'AlertEventMessage';
